export const isClose = (x: number, y: number, epsilon: number): boolean => {
  const diff = Math.abs(x - y);
  return diff <= epsilon;
};
